<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.student.studentApplicationImport')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.student.studentApplicationImport')}}</div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="border border-dark p-2 mb-5">
                                    <a href="/templates/ExampleApplicationImportFile.zip" class="d-block"
                                        download>{{$t('form.import.downloadApplication')}}</a>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">{{$t('form.student.uploadFile')}}</label>

                                    <vue-dropzone
                                        id="dropzone"
                                        :dictCancelUpload="true"
                                        ref="myVueDropzone"
                                        :options="dropzoneOptions"
                                        @vdropzone-sending="importingData"
                                        @vdropzone-complete="fileSubmitted"
                                        @vdropzone-processing="isLoading = true"
                                    ></vue-dropzone>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";

export default {
    props: ["permissions", "dateFormat", "user"],
    components: {
        vueDropzone: vue2Dropzone,
    },

    data() {
        return {
            students:[],
            alert: false,
            alertClass: "",
            alertMessage: "",

            isLoading: false,
            fullPage: true,

            dropzoneOptions: {
                url: "/api/students/upload-application-documents",
                headers: {
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content,
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
                thumbnailWidth: 150, // px
                thumbnailHeight: 150,
                acceptedFiles: ".zip", // Only accept ZIP files
                maxFilesize: 100, // 100MB limit
                dictDefaultMessage: "Drop your ZIP file here or click to upload",
            },
        };
    },

    mounted() {

        if (!this.permissions.createImportApplications) {
            this.$router.push("/");
            return;
        }
    },

    methods: {
        // Prepare form data before sending the file
        importingData(file, xhr, formData) {
            // Add any additional data you want to send with the file
            formData.append("student_id", "optional_student_id"); // Example: if you need to associate with a student
        },

        // Handle the response after the file is uploaded
        async fileSubmitted(response) {
            this.isLoading = false;

            try {
                const data = JSON.parse(response.xhr.response);

                if (data.success) {
                    this.students = data.students;
                    localStorage.setItem('students',JSON.stringify(this.students))
                    this.showAlert("Files uploaded successfully!", "success");

                    if (data.students && data.students.length > 0) {
                        this.$router.push({
                            name: "StudentApplicationDocumentsImportPreview",
                            params: { students: data.students },
                        });
                    } else {
                        this.showAlert("No student data found in the uploaded files.", "warning");
                    }
                } else {
                    this.showAlert(data.message || "An error occurred during file upload.", "danger");
                }
            } catch (error) {
                this.showAlert("An error occurred while processing the file.", "danger");
                console.error(error); // Debugging: Log the error
            }
        },

        // Show alert messages
        showAlert(msg, cls = "success") {
            this.alertMessage = msg;
            this.alertClass = cls;
            this.alert = true;
        },
    },
};
</script>